export const STEPS = ['step1', 'step2', 'step3', 'step4', 'step5', 'step6', 'step7'];
export const PAUSE_KEY = 'collectionPausedAt';

export const ERROR_MESSAGES = {
    DEFAULT: 'An error occurred while deleting your application. Please try again later.',
    NETWORK: 'Connection error. Please check your network connection and try again.',
    UNAUTHORIZED: 'Your session has expired. Please log in again.',
    FORBIDDEN: 'You don&apos;t have permission to delete this application.',
    NOT_FOUND: 'Application not found. It may have already been deleted.',
    SERVER: 'Server error. Please try again later or contact support.'
};

export const getErrorMessage = (error) => {
    if (error.message?.includes('CORS') || error.message?.includes('Network')) {
        return ERROR_MESSAGES.NETWORK;
    }

    const status = error.response?.status;

    switch (status) {
        case 401:
            return ERROR_MESSAGES.UNAUTHORIZED;
        case 403:
            return ERROR_MESSAGES.FORBIDDEN;
        case 404:
            return ERROR_MESSAGES.NOT_FOUND;
        default:
            if (status >= 500) {
                return ERROR_MESSAGES.SERVER;
            }
            return ERROR_MESSAGES.DEFAULT;
    }
};
